import { PAYMENT_TYPE_PAYPAL } from '@/common/constants/constants';
import { TextField, Typography } from '@eventbrite/marmalade';
import React, { useState } from 'react';

export interface PaypalDetailsProps {
  isDisabled: boolean;
  setLastFourDigits: (digits: string) => void;
  setCardType: (type: string) => void;
  validatedTxnId?: string;
}

const PaypalIdDetails: React.FC<PaypalDetailsProps> = ({
  isDisabled,
  setLastFourDigits,
  setCardType,
  validatedTxnId,
}) => {
  const [transactionId, setTransactionId] = useState('') || '';

  const handlePaypalTransactionIdChange = (
    transactionId: string,
    name: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setTransactionId(transactionId);
    setLastFourDigits(transactionId);
    setCardType(PAYMENT_TYPE_PAYPAL);
  };

  return (
    <div className="paypal-details">
      <TextField
        data-testid="paypal_transation_id"
        id="paypal_transation_id"
        label="Merchant order ID or Invoice ID"
        required
        type="text"
        onChange={handlePaypalTransactionIdChange}
        hasError={!!validatedTxnId}
        helperText={validatedTxnId}
        value={transactionId}
        crossOrigin={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        disabled={isDisabled}
      />
      <Typography variant="body-sm">
        Log in to your PayPal account, select “Activity,” and then select the Eventbrite order.
        <br />
        Example: 2590394741-10293736619
      </Typography>
    </div>
  );
};

export default PaypalIdDetails;
